import AdminGongSettings from './AdminGongSettings';

export default AdminGongSettings;
